import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SentimentVeryDissatisfiedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"sentiment_very_dissatisfied"}/>
}
